module.exports = __webpack_public_path__ + "img/top@2x.076f1e5c.png";